import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Loading from "../../../../components/Loading/Loading";
import { useLocation } from "react-router-dom";
import RouteIcon from "@mui/icons-material/Route";
import TimelineIcon from "@mui/icons-material/Timeline";
import MapRunningClub from "../../../../components/Map/MapRunniClub";
import InfoRunningClubUser from "./infoRunningClubUser";
import ModalGoOutRunningClub from "./ModalGoOutRunningClub";
import { getGalleryClubAPI } from "../../../../services/rest/runningsClubs/runningClubUser";
import toast from "react-hot-toast";
import { handleError } from "../../../../utils/handleError";

const ProfileRunningClubUser = () => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const runningClubSelected = location.state?.runningClub ?? undefined;
  const ofUser = location.state?.ofUser ?? false;
  const [galleryList, setGalleryList] = useState([]);

  const getGalleryClub = async () => {
    try {
      const responseGallery = await getGalleryClubAPI(runningClubSelected?._id);
      setGalleryList(responseGallery ?? []);
      setLoading(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(
        `En estos momentos no se pudo obtener la galería. \n ${message}`
      );
    }
  };

  useEffect(() => {
    getGalleryClub();
  }, []);

  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5,
      }}
    >
      <Loading loading={loading} />
      <ModalGoOutRunningClub
        runningClub={runningClubSelected}
        open={open}
        setLoading={setLoading}
        setOpen={setOpen}
      />

      <Box
        sx={{
          display: "flex",
          gap: 4,
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box
          sx={{
            backgroundColor: "rgba(128, 128, 128, 0.55)",
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 2,
            paddingBottom: 2,
            borderRadius: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            sx={{ fontSize: 24, color: "#e7ef7d", textAlign: "center" }}
          >
            {runningClubSelected?.nameRunningClub ??
              "Nombre de la club de corredores."}
          </Typography>
          <Box sx={{ display: "flex", gap: 4 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <RouteIcon className="text-primary " />
                <Typography>Nivel</Typography>
              </Box>
              <Typography className="text-primary ">
                {runningClubSelected?.level ?? 0}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <TimelineIcon className="text-primary " />
                <Typography>Tipo de entrenamientos.</Typography>
              </Box>
              <Typography className="text-primary ">
                {runningClubSelected?.typeTraining ?? ""}
              </Typography>
            </Box>
            <Box>
              <Typography>Horarios de entrenamiento.</Typography>
              <Box>
                {runningClubSelected?.trainingDays &&
                  runningClubSelected?.trainingDays.map((day, index) => (
                    <Typography key={index} className="text-primary">
                      {day?.day ?? "Día"}:
                      {day?.times &&
                        day.times.map((time, index) => {
                          return ` ${time} hrs ${index === runningClubSelected?.trainingDays.length - 1 ? "." : ","}`;
                        })}
                    </Typography>
                  ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ width: "100%" }}>
        <InfoRunningClubUser
          runningClub={runningClubSelected}
          setLoading={setLoading}
          ofUser={ofUser}
          setOpen={setOpen}
          galleryList={galleryList}
        />
      </Box>
      <Box
        sx={{
          width: "80%",
          height: 500,
          borderRadius: 5,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            backgroundColor: "rgba(128, 128, 128, 0.55)",
            display: "flex",
            flexDirection: "column",
            gap: 1,
            paddingTop: 2,
            paddingBottom: 2,
          }}
        >
          <Typography sx={{ fontSize: 20, textAlign: "center" }}>
            Ubicación de entrenamientos.
          </Typography>
          <Typography
            sx={{ fontSize: 18, color: "#e7ef7d", textAlign: "center" }}
          >
            {runningClubSelected?.descriptionLocation ?? "Sin dato."}
          </Typography>
        </Box>
        <MapRunningClub runningClub={runningClubSelected} />
      </Box>
    </Box>
  );
};

export default ProfileRunningClubUser;
